module.exports = __webpack_public_path__ + "static/media/emma_inscripcion_inicio.b04e50c3.png";